import React from 'react';
import { Grid, Box, Text, Flex, Spinner } from '@chakra-ui/react';

const KPIS = [
  { key: 'total', label: 'Grabaciones', color: '#574feb', foot: 'en el periodo' },
  { key: 'processed', label: 'Subidas OK', color: '#10B981', foot: null },
  { key: 'in_queue', label: 'En proceso', color: '#3B82F6', foot: 'descarga / upload' },
  { key: 'failed', label: 'Con error', color: '#EF4444', foot: 'requiere revisión' },
  { key: 'unmatched', label: 'Sin match', color: '#F59E0B', foot: 'asociar manual' },
];

export default function ZoomKpiRow({ summary, loading }) {
  return (
    <Grid templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' }} gap={3} mb={5}>
      {KPIS.map(({ key, label, color, foot }) => (
        <Box
          key={key}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="14px"
          p={4}
        >
          <Flex justify="space-between" align="center">
            <Text fontSize="11px" color="gray.500" fontWeight="500" letterSpacing=".02em" textTransform="uppercase">
              {label}
            </Text>
            <Box w="8px" h="8px" borderRadius="999px" bg={color} />
          </Flex>
          <Text fontSize="28px" fontWeight="700" color="gray.900" letterSpacing="-.02em" lineHeight="1" mt={2}>
            {loading ? <Spinner size="sm" color={color} /> : summary?.[key] ?? '—'}
          </Text>
          {foot && (
            <Text fontSize="12px" color="gray.400" mt={1}>
              {key === 'processed' && summary?.total ? `${Math.round((summary.processed / summary.total) * 100)}% éxito` : foot}
            </Text>
          )}
        </Box>
      ))}
    </Grid>
  );
}
